


































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";

@Component({
  components: {
    BPopover,
  },
  //computed: mapState("gaps", ["insurers"]),
})
export default class AdmisionDischargeFilter extends Vue {
  id = "admission-discharge-filter-popover";
  target = "admission-discharge-filter-target";
  admissionDischarge: Array<any> = [
    { id: "ADM", name: "Admission" },
    { id: "DSC", name: "Discharge" },
    { id: "INA", name: "Inactive" },
    { id: "OTH", name: "Other" },
  ];
  list = Array<any>();

  async checkAdmissionDischarge() {
    this.list.forEach((x) => {
      x.checked = true;
    });
  }
  async uncheckAdmissionDischarge() {
    this.list.forEach((x) => {
      x.checked = false;
    });
  }

  get checkedAdmissionDischarge(): Array<any> {
    return this.list
      .filter((x) => {
        return x.checked;
      })
      .map((x) => x.id);
  }


  search() {
    var filter = JSON.parse(JSON.stringify(this.checkedAdmissionDischarge));
    this.$store.commit("gaps/SET_REPORT_ADMISSION_DISCHARGE_FILTER", filter);
    this.close();
  }
  clear() {
    this.uncheckAdmissionDischarge();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { admissionDischargeList } = this.$store.state.gaps.filter.report;
    this.list = JSON.parse(JSON.stringify(this.admissionDischarge)).map(
      (ss) => {
        ss.checked = admissionDischargeList.includes(ss.id);
        return ss;
      }
    );
  }
}
